import detectEthereumProvider from "@metamask/detect-provider";

const getEthereumProvider = async () => {
  const metamaskProvider = await detectEthereumProvider();
  return metamaskProvider;
};

export default getEthereumProvider;
